import { makeStyles } from '@material-ui/core/styles';
import tinyColor from 'tinycolor2';
var inputColorWidth = 42;
export var styles = makeStyles(function (theme) { return ({
    formControl: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        position: 'relative',
    },
    input: {
        height: inputColorWidth,
        borderRadius: 8,
        paddingTop: theme.spacing(2.25),
        paddingBottom: theme.spacing(2.25),
        paddingLeft: theme.spacing(1),
        paddingRight: inputColorWidth + theme.spacing(1),
        border: '1px solid rgba(60, 60, 67, 0.29)',
        overflow: 'hidden',
        'label + &': {
            marginTop: '24px',
        },
    },
    inputError: {
        borderColor: theme.palette.error.main,
    },
    inputColor: function (_a) {
        var color = _a.color;
        return ({
            width: inputColorWidth,
            height: '100%',
            position: 'absolute',
            top: 0,
            right: 0,
            boxShadow: "0 0 4px rgba(0,0,0,0.2)",
            background: color,
            cursor: 'pointer',
        });
    },
    pickerWrapper: {
        position: 'relative',
    },
    pickerContainer: function (_a) {
        var color = _a.color;
        return ({
            position: 'absolute',
            top: 10,
            right: inputColorWidth / 2,
            width: 182,
            boxShadow: '0 4px 4px rgba(0,0,0,0.25)',
            background: 'white',
            padding: '90px 12px 20px',
            borderRadius: 3,
            transform: 'translate(50%, 0)',
            '&:before': {
                content: '""',
                position: 'absolute',
                top: -9,
                left: '50%',
                border: '10px solid transparent',
                borderBottomColor: color,
                borderTop: 'none',
                transform: 'translate(-50%, 0)',
            },
        });
    },
    pickerText: function (_a) {
        var color = _a.color;
        return ({
            fontSize: 16,
            lineHeight: '76px',
            height: '76px',
            width: '100%',
            textAlign: 'center',
            position: 'absolute',
            top: 0,
            left: 0,
            background: color,
            color: tinyColor(color).isLight() ? theme.palette.common.black : theme.palette.common.white,
            boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
        });
    },
    button: {
        display: 'inline-block',
        padding: 0,
    },
    buttonText: {},
    redoIcon: {
        transform: 'scaleX(-1)',
    },
}); });
